const statesByProductId = new Map();

const createState = () => {
  let resolveReady;
  const ready = new Promise((resolve) => {
    resolveReady = resolve;
  });

  return {
    ready,
    resolveReady,
    isReady: false,
    hasProductSummary: false,
    version: undefined,
    viewed: false,
  };
};

const getState = (productId) => {
  if (productId === null || productId === undefined) {
    return null;
  }

  const key = String(productId);
  if (!statesByProductId.has(key)) {
    statesByProductId.set(key, createState());
  }

  return statesByProductId.get(key);
};

const getSummaryState = (state) => ({
  hasProductSummary: state.hasProductSummary,
  productSummaryVersion: state.version,
});

export const setProductSummaryTrackingState = (productId, summary) => {
  const state = getState(productId);
  if (!state) {
    return;
  }

  state.hasProductSummary = Boolean(summary);
  state.version = summary?.version;

  if (!state.isReady) {
    state.isReady = true;
    state.resolveReady(getSummaryState(state));
  }
};

export const waitForProductSummaryTrackingState = (productId) => {
  const state = getState(productId);
  if (!state) {
    return Promise.resolve({
      hasProductSummary: false,
      productSummaryVersion: undefined,
    });
  }

  return state.isReady ? Promise.resolve(getSummaryState(state)) : state.ready;
};

export const markProductSummaryViewed = (productId) => {
  const state = getState(productId);
  if (state?.isReady && state.hasProductSummary) {
    state.viewed = true;
  }
};

export const wasProductSummaryViewed = (productId) =>
  Boolean(getState(productId)?.viewed);
